import { Link } from 'react-router-dom';
import { gridItems } from '@/mocks/homeData';

const tintMap: Record<string, string> = {
  pink: 'bg-primary-50',
  mint: 'bg-accent-50',
  gray: 'bg-secondary-50',
  amber: 'bg-accent-100',
};

export default function TrendingGrid() {
  return (
    <section className="w-full py-10 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <p className="text-xs font-heading text-foreground-500 uppercase tracking-wider mb-2">Editor&apos;s Pick</p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight">
            编辑精选
            <br />
            <span className="italic font-heading">不吃后悔系列</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {gridItems.map((item) => (
            <Link
              key={item.id}
              to="/"
              className="group cursor-pointer"
            >
              <div className={`rounded-2xl overflow-hidden ${tintMap[item.bgTint] || 'bg-background-100'}`}>
                <div className="relative w-full aspect-[3/4] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} - 51吃瓜app`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-3 md:p-4 bg-background-50">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{item.subtitle}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}